import { StyleSheet, View } from '@react-pdf/renderer'
import { Style } from '@react-pdf/types'

import TableBody from './TableBody'
import TableCharges from './TableCharges'
import TableFooter from './TableFooter'
import TableHeader from './TableHeader'

const styles = StyleSheet.create({
  table: {
    width: '100%',
  },
})

interface TableProps {
  headers?: string[]
  values: string[][]
  valueRowStyle?: Record<number, Style>
  totals?: string[]
  charges?: string[][]
  widths: number[]
}

const Table = ({ data }: { data: TableProps }) => {
  return (
    <View style={styles.table}>
      {data.headers && (
        <TableHeader values={data.headers} widths={data.widths} />
      )}
      <TableBody
        valueRowStyle={data.valueRowStyle}
        values={data.values}
        widths={data.widths}
      />
      {data.totals && <TableFooter values={data.totals} widths={data.widths} />}
      {data.charges && (
        <TableCharges values={data.charges} widths={data.widths} />
      )}
    </View>
  )
}
export default Table
